export default "__VITE_ASSET__DwxyVHdG__"